const FILE_TYPES = {
  pdf: 0,
  docx: 1,
  doc: 2,
  xls: 3,
  xlsx: 4,
  eml: 5,
  jpg: 6,
  jpeg: 7,
  png: 8,
  msg: 9,
  zip: 10,
  tiff: 11,
  ppt: 12,
  pptx: 13,
  xml: 14,
  txt: 15,
  gif: 16,
  cad: 17,
  docm: 18,
  dotx: 19,
  dotm: 20,
  dot: 21,
  xps: 22,
  mht: 23,
  mhtml: 24,
  htm: 25,
  rtf: 26,
  odt: 27,
  html: 28,
  oft: 29,
  csv: 30,
  xlsm: 31,
  hwp: 32,
};

export { FILE_TYPES };
